import React, { Component }  from 'react';
import { Circle, DescriptionWrapper, ProjectBackground, FrameworkWrapper, HighlightWrapper, ProfileBox, ProjectWrapper, SocialWrapper, ProjectCard, YearWrapper, TimeLine, TimeLineObject, Line, LineMark } from '../Components/Components';
import emoji from '../images/profile.jpg';

import ig from '../images/Icons/ig.png';
import ln from '../images/Icons/ln.png';
import gh from '../images/Icons/gh.png';
import el from '../images/Icons/el.png';
import pn from '../images/Icons/pn.png';

import csharp from '../images/Icons/csharp.png';
import html5 from '../images/Icons/html5.png';
import css3 from '../images/Icons/css3.png';
import javascript from '../images/Icons/javascript.png';
import python from '../images/Icons/python.png';
import mysql from '../images/Icons/mysql.png';
import dotnet from '../images/Icons/net.png';
import django from '../images/Icons/django.png';
import react from '../images/Icons/react.png';
import azure from '../images/Icons/azure.png';
import aws from '../images/Icons/aws.png';
import selenium from '../images/Icons/selenium.png';

const responseOne = [
    {
        'id': 1,
        'imagePath': 'instagram.jpg',
        'title': 'ClearServices Group',
        'desc': 'It was developed for a small business. Developed a back-end with Django Rest Framework. A responsive front-end was developed with React. Front-end of this web application was deployed on Firebase and the back-end is deployed on AWS.',
        'theme': ['#47a4ed', '#ffffff'],
        'iconOne' : django,
        'iconTwo' : react,
        'year': '2022',
        'url': 'https://clearservices.ca'
    },
    {
        'id': 2,
        'imagePath': 'jobsearch.jpg',
        'title': 'Yahoo Finance Scraper',
        'desc': 'This project scrapes Yahoo Finance comment section for given stocks every day at midnight based on defined keywords. It saves the scraped data to database, which is then served with API to client.',
        'theme': ['#2e3130', '#f7d616'],
        'iconOne' : django,
        'iconTwo' : react,
        'year': '2021',
        'url': 'https://snowsscraper.web.app/'
    },
    {
        'id': 3,
        'imagePath': 'clearservices.jpg',
        'title': 'JukeBox',
        'desc': 'This project is built for a client as a freelance project. Client is in music industry. His problem; to be able to privately share music between collegues. He wanted to be able to share music for a three different periods of time.',
        'theme': ['#3a3a3a', '#f5b90b'],
        'iconOne' : django,
        'iconTwo' : react,
        'year': '2020',
        'url': 'https://privatejukebox-3f362.web.app/'
    },
    {
        'id': 4,
        'imagePath': 'yahooscraper.jpg',
        'title': 'Instagram',
        'desc': 'This is a side project where I designed an alternative Instagram application for desktop. I used React as front-end. Net Core was used in the backend. I have found this sample UI online and designed based on that.',
        'theme': ['#3d3f50', '#f38e53'],
        'iconOne' : dotnet,
        'iconTwo' : react,
        'year': '2021',
        'url': ''
    },
    {
        'id': 5,
        'imagePath': 'jukebox.jpg',
        'title': 'Job Scraper',
        'desc': 'This project was built as an alternative to regular job search. It works like every other job posting board. However, with this application when you click the search button; it not only searches at one, but at five different job boards.',
        'theme': ['#ffffff', '#ffa537'],
        'iconOne' : django,
        'iconTwo' : react,
        'year': '2020',
        'url': ''
    },
    {
        'id': 6,
        'imagePath': 'instagram.jpg',
        'title': 'Scheduler App',
        'desc': 'A side project started recently.',
        'theme': ['#ffffff', '#ffffff'],
        'iconOne' : '',
        'iconTwo' : react,
        'year': '2022',
        'url': 'https://snowsschedulerapp.web.app/'
    },
    {
        'id': 7,
        'imagePath': 'jobsearch.jpg',
        'title': 'React Sample Project',
        'desc': 'A side project.',
        'theme': ['#efefef', '#ffffff'],
        'iconOne' : '',
        'iconTwo' : react,
        'year': '2019',
        'url': 'https://snowsdemoshop-241ea.web.app/'
    },
]

const responseTwo = [
    {
        'id': 1,
        'name': 'ClearServices-Freelance',
        'description': 'ClearServices - Full Stack Developer\n\n- Developed a responsive web application for business needs.\n- Developed a back-end with Django Rest Framework (REST API) and SQL.\n- Developed a responsive front-end with React.\n- Deployed front-end on Firebase.\n- Deployed back-end on AWS.',
        'startDate': 'January 2020'
    },
    {
        'id': 2,
        'name': 'PowerObjects-Software Engineer',
        'description': 'PowerObjects - Software Engineer\n\n- Design and develop specific applications or parts of applications.\n- Participate in daily scrums with Scrum Master.\n- Design ecosystems for Microsoft environment with Azure Dev-Ops.\n- Test applications using development languages.',
        'startDate': 'January 2021'
    },
    {
        'id': 3,
        'name': 'Motorola-Cloud Engineer',
        'description': 'Motorola - Cloud Engineer\n\n- Experience developing cloud-based solutions, including working with CI/CD pipelines.\n- Knowledge and working experience developing REST based APIs and implementing microservice principles and architectures.\n- Strong background in modern software development practices, principles, and tools including C#/.NET and Azure.',
        'startDate': 'March 2022'
    }
]


class Main extends Component {

    state = {
        summary : ''
    }

    companyNameFix = (name) => {
        return name.split('-');
    }

    displayInfo(info) {
        this.setState({summary: info});
        document.getElementById("summaryBox").style.display = 'block';
    }

    handleMouseLeave() {
        this.setState({summary: ''});
        document.getElementById("summaryBox").style.display = 'none';
    }

    render(){   

        let ProjectRender = responseOne.map(content => {
            return  <ProjectBackground key={content.id} style={{backgroundImage: `url(${require('../images/' + content.imagePath).default})`, borderRadius: '10px'}}>
                        <ProjectCard>
                            <h3>{content.title}</h3>
                            <DescriptionWrapper>
                                <p>{content.desc}</p>
                            </DescriptionWrapper>
                            <FrameworkWrapper>
                                <div style={{lineHeight: '0', display: 'flex'}}>
                                    {content.theme.map((color,index) => {
                                        return <Circle key={index} style={{backgroundColor: color}} />
                                    })}
                                </div>
                                <div style={{lineHeight: '0'}}>
                                    {content.iconOne ? <img src={content.iconOne} alt="icon" /> : null}
                                    <img src={content.iconTwo} alt="icon" />
                                </div>
                            </FrameworkWrapper>
                            {content.url ? <a href={content.url} target="_blank" rel="noreferrer">View Project</a> :  <a href={'/'} style={{pointerEvents: 'none'}}>Private</a>}
                            <YearWrapper>
                                {'Updated ' + content.year}
                            </YearWrapper>
                        </ProjectCard>
                    </ProjectBackground>
        });

        let employmentRender = responseTwo.map(content => {
            let positionName = this.companyNameFix(content.name);
            return  <TimeLineObject key={content.id}>
                        <p id="company">{positionName[0] + '\n' + positionName[1]}</p>
                        <div style={{position: 'relative'}}>
                            <Line />
                            <LineMark />
                        </div>
                        <p>{content.startDate}</p>
                    </TimeLineObject>
        });

        return(
            <>  
                <ProfileBox>

                    <div style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        <img id="profile" src={emoji} alt='icon' />
                        <div style={{width: '45%', height: '20vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-around'}}>
                            <SocialWrapper>
                                <a href="https://github.com/snowman00000/"><img src={gh} alt='githublogo'/></a>
                            </SocialWrapper>
                            <SocialWrapper>
                                <a href="https://www.instagram.com/y4sirr/"><img src={ig} alt='iglogo'/></a>
                                <a href="https://www.linkedin.com/in/yasir-k-0549061b0/"><img src={ln} alt='linkedinlogo'/></a>
                            </SocialWrapper>
                            <SocialWrapper>
                                <a href="tel:+12269883365"><img src={pn} alt='phonelogo'/></a>
                                <a href="mailto:kara.yasir@outlook.com"><img src={el} alt='emaillogo'/></a>
                            </SocialWrapper>
                        </div>
                    </div>

                    <div style={{display: 'flex', width: '100%', flexDirection: 'column'}}>
                        <h3 style={{margin: '0', marginTop: 'min(3vw, 20px)'}}>Yasir Kara</h3>
                        <p style={{color: '#A8A8A8', marginBottom: 'min(5vw, 30px)'}}>
                            Vancouver 🇨🇦<br />
                            SoccerLife &#9917;<br />
                            Cloud Engineer at Motorola &#128187;
                        </p>
                        {/* <p>Experienced with object oriented analysis, design and programming techniques to create business applications. Passionate towards software architecture and design combined with sensitivity to serve the needs of businesses balanced with the delivery of high quality solutions.</p> */}
                    </div>
                    
                    <h3 style={{width: '100%'}}>Employment</h3>
                    
                    <TimeLine>
                        {employmentRender}
                    </TimeLine>

                    <h3 style={{width: '100%'}}>Highlights</h3>

                    <HighlightWrapper>
                        <img title="C#" src={csharp} alt="icon" />
                        <img title="Html5" src={html5} alt="icon" />
                        <img title="Css3" src={css3} alt="icon" />
                        <img title="JavaScript" src={javascript} alt="icon" />
                        <img title="Python" src={python} alt="icon" />
                        <img title="MySql" src={mysql} alt="icon" />
                        <img title=".Net Framework" src={dotnet} alt="icon" />
                        <img title="Django" src={django} alt="icon" />
                        <img title="React" src={react} alt="icon" />
                        <img title="Aws" src={aws} alt="icon" />
                        <img title="Azure" src={azure} alt="icon" />
                        <img title="Selenium" src={selenium} alt="icon" />
                    </HighlightWrapper>

                </ProfileBox>
                
                <h1 style={{textAlign: 'center', marginTop: 'min(20vw, 150px)'}}>Projects</h1>

                <ProjectWrapper>
                    {ProjectRender}
                </ProjectWrapper>

                <p style={{fontSize: 'min(3vw, 15px)', marginBottom: '5vh', textAlign: 'center'}}>Copyright © {new Date().getFullYear()} SnowMan. All rights reserved.</p>
            </>
        );
    }
}

export default Main;
